<template>
  <div class="outer-box">
    <h4>Increase Caller ID Verification Limit</h4>

    <div class="inner-box" style="text-align: left; width: 500px">
      <input class="hl_input--wrap" type="text" placeholder="Location ID" v-model="locationId" />

      <button class="btn btn-primary mt-4" @click="increaseCallerIdVerificationLimit">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Increase Limit </span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { LCPhoneService } from "@/services";

export default {
  data() {
    return {
      locationId: "",
      processing: false,
      response: null,
    };
  },
  methods: {
    async increaseCallerIdVerificationLimit() {
      try {
        this.processing = true;
        this.response = await LCPhoneService.increaseCallerIdVerificationLimit(this.locationId);
      } catch (err) {
        this.response = err.response.data;
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>
